export default "__VITE_ASSET__BMaq5t_E__"